// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"6f8fa5a5","484":"fa02eca1","703":"2a8e6de8","849":"addc2a44","851":"95edf893","950":"06d67a9f"}[chunkId] + ".chunk.js";
};